import { PixoSpatial, PixoSpatialCoord } from "../../model/Pixospatial";
import { MapService } from "../../services/map.service";
import { AnyHandler } from "../../types/@types/sl-v-types";
import { D3SelectedGroup, EventMap, IDrawContext, IDrawer, IMapInteraction, MakeInteractionGroup, RemoveInteractionGroup } from "./draw-pane-utils";
import { DrawPaneComponent } from "./draw-pane.component";
import * as d3 from 'd3';

export class FeatureMode implements IMapInteraction, IDrawContext {
  context: IDrawer;
  interactionGroup?: D3SelectedGroup | undefined;
  public enabled = false;
  public pixo: PixoSpatial;

  private drawRect: D3SelectedGroup;
  private handler?: AnyHandler;
  private eventMap?: EventMap;

  public get drawWidth() {
    return !!this.context ? this.context?.drawWidth : 0;
  }
  public get drawHeight() {
    return !!this.context ? this.context?.drawHeight : 0;
  }


  TogglePausing(onOrOff: boolean): void {
    if (onOrOff === true) {
      this.enabled = false;
      return;
    }
    this.enabled = !!this.interactionGroup;
  }
  Disable(): void {
    this.enabled = false;
    if (!this.interactionGroup) return;
    RemoveInteractionGroup(this.interactionGroup!, this.eventMap!);
  }
  Enable(context: IDrawer, drawRect: D3SelectedGroup, handler: AnyHandler): void {
    this.context = context;
    this.pixo = this.context.spatialContext;
    this.drawRect = drawRect;
    this.handler = handler;
    this.eventMap = {
      click: this.Click.bind(this),
      dblClick: () => { }
    }
    this.interactionGroup = MakeInteractionGroup(this, this.drawRect, this.eventMap);
    this.enabled = true;
  }
  GetMouseCoord(event): PixoSpatialCoord {
    const coord = this.pixo.PixoSpatialCoord(this.pixo.PixoPt({ x: event.layerX, y: event.layerY }));
    return coord;
  }
  Click() {
    if (!this.enabled) return;
    if (this.handler) this.handler(this.GetMouseCoord(d3.event));

  }
  DblClick() {
    // do nothing
  }

}
